import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/icon/gamburger-menu-icon.svg")